import styled from "styled-components";
import { Link } from "gatsby";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
`;

export const HR = styled.hr`
  height: 1px;
  background-color: #bababa;
  margin: 0;
`;

export const Title = styled.h3`
  color: #fff6ed;
  font-size: 36px;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: 0.205px;
  text-transform: uppercase;
  margin: 0;

  @media (max-width: 600px) {
    font-size: 29px;
    line-height: 26px;
    letter-spacing: 0.164px;
  }
`;

export const Description = styled.p`
  margin: 0;
  color: #fff6ed;
  font-size: 20px;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: 0.205px;
`;

export const MenuLink = styled(Link)`
  color: #fff6ed;
  font-size: 20px;
  font-weight: 400;
  line-height: 32.742px;
  letter-spacing: 0.205px;
  text-decoration-line: underline;
`;

export const ExternalLink = styled.a`
  color: #fff6ed;
  font-size: 20px;
  font-weight: 400;
  line-height: 32.742px;
  letter-spacing: 0.205px;
  text-decoration-line: underline;
`;
